import { D, MONEY_MIN_SCALE } from './decimal.js';
/**
 * Dreiwertiger Vergleich: `-1`, `0` oder `1`.
 *
 * Vergleicht Werte, nicht Zeichenketten. `money('1.5')` und `money('1.500')` sind
 * derselbe Betrag — was die kanonische Darstellung ohnehin schon sicherstellt.
 */
export function cmp(a, b) {
    const result = new D(a).comparedTo(b);
    if (result < 0)
        return -1;
    if (result > 0)
        return 1;
    return 0;
}
/** Gleichheit dem Wert nach. */
export function eq(a, b) {
    return cmp(a, b) === 0;
}
/** Ist der Betrag null? Gilt für `"0.00"` ebenso wie für `"0.000"`. */
export function isZero(a) {
    return new D(a).isZero();
}
/**
 * Ist der Betrag echt kleiner als null?
 *
 * Die Null ist nicht negativ — auch dann nicht, wenn sie aus einer Rechnung mit
 * negativem Vorzeichen stammt.
 */
export function isNegative(a) {
    return new D(a).lessThan('0');
}
/**
 * Die Anzahl der Nachkommastellen der kanonischen Darstellung.
 *
 * Gemessen wird die Darstellung, nicht der mathematische Wert: `money('7')` ist
 * `"7.00"` und hat damit die Skala 2. Genau diese Zahl entscheidet, ob ein Betrag
 * auf eine Rechnung darf.
 */
export function scaleOf(value) {
    const separator = value.indexOf('.');
    return separator === -1 ? 0 : value.length - separator - 1;
}
/**
 * Lässt sich der Wert verlustfrei in Cent ausdrücken?
 *
 * Beträge mit mehr als zwei Nachkommastellen sind Zwischenergebnisse. Sie dürfen
 * gerechnet, aber weder gebucht noch gedruckt werden, bevor jemand ausdrücklich
 * gerundet hat.
 */
export function hasCentScale(value) {
    return scaleOf(value) <= MONEY_MIN_SCALE;
}
//# sourceMappingURL=compare.js.map